import { render, staticRenderFns } from "./vippi.vue?vue&type=template&id=e3ac056e&"
import script from "./vippi.vue?vue&type=script&lang=js&"
export * from "./vippi.vue?vue&type=script&lang=js&"
import style0 from "./vippi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports